import styled from 'styled-components';

import { Box } from '../box';
import { ChipVariant } from './chip.types';

export const Chip = styled(Box)<{ variant: ChipVariant }>`
	width: fit-content;
	background: ${({ theme: { chip }, variant }) => chip[variant].background};
	color: ${({ theme: { chip }, variant }) => chip[variant].color};
	padding: ${({ theme: { chip }, variant }) => chip[variant].padding};
	border-radius: ${({ theme: { chip }, variant }) => chip[variant].borderRadius};
	border: ${({ theme: { chip }, variant }) => `1px solid ${chip[variant].borderColor}`};

	& p {
		width: max-content;
	}
`;
